<template>
  <div id="stent-inschrijven-spelshow">
    <div v-if="!done">
      <form class="" enctype="multipart/form-data" v-on:submit.prevent="submit">
        <div class="row g-4 gy-md-5 gx-md-6 mb-6">
          <div class="col-12">
            <div class="separator-title-container">
              <h5>Algemene gegevens</h5>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.voornaam.length > 0}">
              <label>Voornaam</label>
              <input type="text" class="form-control" v-model="form.data.voornaam" _required>

              <ul v-if="form.errors.voornaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voornaam" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container">
              <label>Tussenvoegsel</label>
              <input type="text" class="form-control" v-model="form.data.voorvoegsels">

              <ul v-if="form.errors.voorvoegsels.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voorvoegsels" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
              </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.achternaam.length > 0}">
              <label>Achternaam</label>
              <input type="text" class="form-control" v-model="form.data.achternaam" _required>

              <ul v-if="form.errors.achternaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.achternaam" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container email-container" :class="{'error': form.errors.email.length > 0}">
              <label>E-mailadres</label>
              <input type="email" class="form-control" v-model="form.data.email" _required>

              <ul v-if="form.errors.email.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.email" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-envelope"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-file" :class="{'error': submitted && form.upload_files.pictures.length === 0}">
              <label for="pictures">Foto's</label>
              <input id="pictures" name="pictures" class="form-control" type="file" ref="pictures" multiple @change="setPicturesFiles" accept=".png,.jpg,.jpeg,.gif,.webp,.bmp" _required>
              <label for="pictures">
                <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
              </label>


              <ul v-if="submitted && !(form.upload_files.pictures.length > 0)" class="stent-form-errors">
                <li class="sis-field-error">We hebben een foto van u nodig.</li>
              </ul>

              <table v-if="form.upload_files.pictures.length > 0" class="sis-upload-table">
                <tr v-for="(file, index) in form.upload_files.pictures" :key="file">
                  <td class="sis-upload-table-filename">
                    <span>{{ file.name }}</span>
                  </td>

                  <td class="sis-upload-table-remove" @click="removePicturesFile(index)">
                    <span>X</span>
                  </td>
                </tr>
              </table>

              <ul v-if="form.upload_errors.pictures.length > 0" class="stent-form-errors">
                <li v-for="error in form.upload_errors.pictures" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <template v-for="n in 5">
                <ul v-if="form.upload_errors[`pictures.${n - 1}`] !== undefined" :key="n" class="stent-form-errors">
                  <li v-for="error in form.upload_errors[`pictures.${n - 1}`]" :key="error" class="sis-field-error">{{ error }}</li>
                </ul>
              </template>

              <i class="btb bt-photo"></i>
              <br />
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-file" :class="{'error': submitted && form.upload_files.documents.length === 0}">
              <label for="documents">C.V.</label>
              <input id="documents" name="documents" class="form-control" type="file" ref="documents" data-upload-type="cv" accept=".pdf" @change="setDocumentsFiles" _required>
              <label for="documents">
                <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
              </label>

              <table v-if="form.upload_files.documents.length > 0" class="sis-upload-table">
                <tr v-for="(file, index) in form.upload_files.documents" :key="file">
                  <td class="sis-upload-table-filename">
                    <span>{{ file.name }}</span>
                  </td>

                  <td class="sis-upload-table-remove" @click="removeDocumentsFile(index)">
                    <span>X</span>
                  </td>
                </tr>
              </table>

              <ul v-if="form.upload_errors.documents.length > 0" class="stent-form-errors">
                <li v-for="error in form.upload_errors.documents" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <template v-for="n in 5">
                <ul v-if="form.upload_errors[`documents.${n - 1}`] !== undefined" :key="n" class="stent-form-errors">
                  <li v-for="error in form.upload_errors[`documents.${n - 1}`]" :key="error" class="sis-field-error">{{ error }}</li>
                </ul>
              </template>

              <i class="btb bt-file"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.geslacht.length > 0}">
              <label>Geslacht</label>
              <select v-model="form.data.geslacht" class="sis-field-input form-select" _required>
                <option :value="null">Maak een keuze</option>

                <option :value="geslacht.key" v-for="geslacht in dropdowns.geslachten" :key="geslacht">
                  {{ geslacht.value }}
                </option>
              </select>

              <ul v-if="form.errors.geslacht.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geslacht" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.geboortedatum.length > 0}">
              <label>Geboortedatum</label>
              <input type="text" v-model="form.data.geboortedatum" class="sis-field-input form-control" placeholder="Formaat: dd-mm-yyyy" _required>

              <ul v-if="form.errors.geboortedatum.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geboortedatum" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-calendar"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.straatnaam.length > 0}">
              <label>Straatnaam</label>
              <input type="text" v-model="form.data.straatnaam" class="sis-field-input form-control" _required>

              <ul v-if="form.errors.straatnaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.straatnaam" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-home"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 input-container">
            <div class="input-container" :class="{'error': form.errors.huisnummer.length > 0}">
              <label>Huisnummer</label>
              <input type="text" v-model="form.data.huisnummer" class="sis-field-input form-control" _required>

              <ul v-if="form.errors.huisnummer.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.huisnummer" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 input-container">
            <div class="input-container">
              <label>Toevoeging</label>
              <input type="text" v-model="form.data.huisnummer_toevoeging" class="sis-field-input form-control">

              <ul v-if="form.errors.huisnummer_toevoeging.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.huisnummer_toevoeging" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.postcode.length > 0}">
              <label>Postcode</label>
              <input type="text" v-model="form.data.postcode" class="sis-field-input form-control" _required>

              <ul v-if="form.errors.postcode.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.postcode" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-map-pin"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.plaats.length > 0}">
              <label>Plaats</label>
              <input type="text" v-model="form.data.plaats" class="sis-field-input form-control" _required>

              <ul v-if="form.errors.plaats.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.plaats" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-label"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.land.length > 0}">
              <label>Land</label>
              <select v-model="form.data.land" class="sis-field-input form-select" _required>
                <option :value="null">Maak een keuze</option>

                <option :value="land.code" v-for="land in dropdowns.landen" :key="land">
                  {{ land.land }}
                </option>
              </select>

              <ul v-if="form.errors.land.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.land" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-globe"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.telefoonnummer.length > 0}">
              <label>Telefoonnummer</label>
              <input type="text" v-model="form.data.telefoonnummer" class="sis-field-input form-control" _required>

              <ul v-if="form.errors.telefoonnummer.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.telefoonnummer" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-phone"></i>
            </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Goedkeuringen</h5>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.av.length > 0}">
                  <input v-model="form.data.av" type="checkbox" name="voorwaarden" id="voorwaarden">
                  <label for="voorwaarden">
                    Algemene voorwaarden
                  </label>

                  <ul v-if="form.errors.av.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.av" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.privacy.length > 0}">
                  <input v-model="form.data.privacy" type="text" name="privacy" id="privacy">
                  <label for="privacy">
                    privacywet
                  </label>

                  <ul v-if="form.errors.privacy.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.privacy" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.social_media.length > 0}">
                  <input v-model="form.data.social_media" type="checkbox" name="social_media" id="social_media">
                  <label for="social_media">
                    Sociale media
                  </label>

                  <ul v-if="form.errors.social_media.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.social_media" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>



          <div class="col-12">
            <div class="separator-title-container">
              <h5>Beschikbaarheid</h5>
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="row g-4 gy-lg-3 gx-lg-6">

                <div class="col-sm-6 col-md-4" v-for="(beschikbaarheid, index) in opdracht.beschikbaarheden" :key="index">
                  <div class="checkbox-container" :class="{'error': form.errors.opdracht_beschikbaarheden.length > 0}">
                      <input :id="`beschikbaarheden_${index}`" :value="beschikbaarheid.id" v-model="form.data.opdracht_beschikbaarheden" type="checkbox" name="beschikbaarheid" >
                      <label :for="`beschikbaarheden_${index}`">{{ beschikbaarheid.datum_tekst }}</label>

                      <ul v-if="form.errors.opdracht_beschikbaarheden.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.opdracht_beschikbaarheden" :key="error" class="sis-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Bijzonderheden</h5>
            </div>
          </div>


          <div class="col-md-4">
            <div class="input-container">
              <label class="sis-field-label">Huidig beroep en voorgaande beroepen (functie/sector)</label>
              <textarea v-model="form.data.bijzonderheden_uiterlijk" class="form-control sis-field-input"></textarea>

              <ul v-if="form.errors.sport_en_hobby.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.sport_en_hobby" :key="error" class="sis-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container">
              <label class="sis-field-label">Hobby's</label>
              <textarea v-model="form.data.sport_en_hobby" class="form-control sis-field-input"></textarea>

            <ul v-if="form.errors.sport_en_hobby.length > 0" class="stent-form-errors">
              <li v-for="error in form.errors.sport_en_hobby" :key="error" class="sis-field-error">{{ error }}</li>
            </ul>

            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container">
              <label class="sis-field-label">De Nederlandse taal betekent voor mij...</label>

              <textarea v-model="form.data.bijzonderheden_overig" class="form-control sis-field-input"></textarea>


            <ul v-if="form.errors.bijzonderheden_overig.length > 0" class="stent-form-errors">
              <li v-for="error in form.errors.bijzonderheden_overig" :key="error" class="sis-field-error">{{ error }}</li>
            </ul>

            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_voorwaarden.length > 0}">
                  <input v-model="form.data.akkoord_voorwaarden" type="checkbox" name="akkoord_voorwaarden" id="akkoord_voorwaarden">
                  <label for="akkoord_voorwaarden">
                    Ik ga akkoord en bevestig dat ik op de hoogte ben van de <a href="/algemene-voorwaarden" target="_blank">Algemene voorwaarden</a>
                    en de <a href="/privacy-policy" target="_blank">Privacy policy</a>.
                  </label>

                  <ul v-if="form.errors.akkoord_voorwaarden.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_voorwaarden" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_bijzondere_persoonsgegevens.length > 0}">
                  <input v-model="form.data.akkoord_bijzondere_persoonsgegevens" type="checkbox" name="akkoord_bijzondere_persoonsgegevens" id="akkoord_bijzondere_persoonsgegevens">
                  <label for="akkoord_bijzondere_persoonsgegevens">
                    Ja, ik geef toestemming voor het verwerken van door mij verstrekte en/of te verstrekken bijzondere persoonsgegevens ten behoeve van de castingprocedure van STENT Casting, zoals beschreven in het Privacy-en Cookiestatement.
                  </label>

                  <ul v-if="form.errors.akkoord_bijzondere_persoonsgegevens.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_bijzondere_persoonsgegevens" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div v-if="loading" class="col-12 input-container">
            <button class="btn btn-primary d-block ms-auto" type="submit" disabled>Aan het laden...</button>
          </div>
          <div v-else class="col-12 input-container">
            <button class="btn btn-primary d-block ms-auto" type="button" data-bs-toggle="modal" data-bs-target="#emailmodal">Verzenden</button>
          </div>

          <EmailModal
            :email="this.form.data.email"
            @edit="editEmail"
            @send="sendSubmit"
          />
        </div>
      </form>
    </div>
    <div v-if="done">
      <h1>Aanmelding voltooid</h1>

      <p>De aanmelding is gelukt.</p>
    </div>
  </div>
</template>

<style scoped>
.sis-upload-table {
  margin-top: 30px;
  font-size: 14px;
  width: 100%;
}

.sis-upload-table td {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sis-upload-table td.sis-upload-table-filename {
  width: 90%;
}

.sis-upload-table td.sis-upload-table-remove {
  width: 10%;
  color: red;
  font-weight: 900;
  cursor: pointer;
  text-align: right;
}

#stent-inschrijven-spelshow input[type='file'] {
  width: 1px !important;
  height: 1px !important;
  opacity: 1 !important;
}
</style>

<script>
import axios from 'axios';
import _helpers from './utils/helpers';
import EmailModal from './components/EmailModal.vue';

export default {
  components: {
    EmailModal,
  },
  data() {
    return {
      opdracht: {
        beschikbaarheden: [],
      },

      dropdowns: {
        booleans: [],
        landen: [],
        geslachten: [],
      },

      form: {
        data: {
          opdracht_beschikbaarheden: [],

          voornaam: null,
          voorvoegsels: null,
          achternaam: null,
          email: null,
          pictures: [],
          documents: [],
          akkoord_voorwaarden: null,
          akkoord_bijzondere_persoonsgegevens: null,
          opdracht_id: null,

          // Goedkeuringen
          av: false,
          privacy: false,
          social_media: false,

          // Algemeen
          geslacht: null,
          geboortedatum: null,
          straatnaam: null,
          huisnummer: null,
          huisnummer_toevoeging: null,
          postcode: null,
          plaats: null,
          land: null,
          telefoonnummer: null,

          // Bijzonderheden
          bijzonderheden_uiterlijk: null,
          sport_en_hobby: null,
          bijzonderheden_overig: null,
        },

        upload_files: {
          pictures: [],
          documents: []
        },

        upload_errors: {
          pictures: [],
          documents: []
        },

        errors: {
          voornaam: [],
          voorvoegsels: [],
          achternaam: [],
          email: [],
          pictures: [],
          documents: [],
          akkoord_voorwaarden: [],
          akkoord_bijzondere_persoonsgegevens: [],

          // Goedkeuringen
          av: [],
          privacy: [],
          social_media: [],

          // Algemeen
          geslacht: [],
          geboortedatum: [],
          straatnaam: [],
          huisnummer: [],
          huisnummer_toevoeging: [],
          postcode: [],
          plaats: [],
          land: [],
          telefoonnummer: [],

          // Bijzonderheden
          bijzonderheden_uiterlijk: [],
          sport_en_hobby: [],
          bijzonderheden_overig: [],

          opdracht_beschikbaarheden: [],
        },

        response: {},
      },

      response_file_photo: null,
      response_file_cv: null,

      done: false,
      loading: false,
      submitted: false,
    };
  },

  mounted() {
    if (_helpers.attribute('opdracht_id') !== undefined) {
      let opdracht_id = _helpers.attribute('opdracht_id');

      this.form.data.opdracht_id = opdracht_id;
      this.retrieveOpdracht(opdracht_id);
    }

    if (!_helpers.attribute('api_endpoint')) return;

    this.retrieveBooleans();
    this.retrieveLanden();
    this.retrieveGeslachten();
  },

  watch: {
    done: function (value) {
      if (value === true) {
        axios.post(`${_helpers.attribute('api_endpoint')}/api/dashboard/users/create_spelshow_aanmelding_done`, {
          data: this.form.data,
          response: this.form.response,
        });
      }
    },

    response_file_photo: function () {
      this.submit();
    },

    response_file_cv: function () {
      this.submit();
    },

    loading: function (value) {
      if (value === false) {
        if (this.submitted === true &&
            this.response_file_photo !== null &&
            this.response_file_cv !== null &&
            _helpers.isEmptyObject(this.form.response) === false &&
            _helpers.allObjectValuesEmptyArray(this.form.errors) &&
            _helpers.allObjectValuesEmptyArray(this.form.upload_errors)) {
          this.activateDone();
        }
      }
    },
  },

  methods: {
    sendSubmit: function () {
      this.loading = true;
      this.submit();
    },
    editEmail: function () {
      this.loading = false;

      _helpers.scrollIntoView('.email-container', {
        block: 'center',
      });
    },
    retrieveBooleans: function () {
      axios.get(`${_helpers.attribute('api_endpoint')}/api/dashboard/booleans`)
        .then((response) => {
          this.dropdowns.booleans = response.data;
        });
    },

    retrieveLanden: function () {
      axios.get(`${_helpers.attribute('api_endpoint')}/api/dashboard/landen`)
        .then((response) => {
          this.dropdowns.landen = (response.data).data;
        });
    },

    retrieveGeslachten: function () {
      axios.get(`${_helpers.attribute('api_endpoint')}/api/dashboard/geslachten`)
        .then((response) => {
          this.dropdowns.geslachten = response.data;
        });
    },

    retrieveOpdracht: function (opdracht_id) {
      axios.get(`${_helpers.attribute('api_endpoint')}/api/dashboard/opdrachten`)
        .then((response) => {
          this.opdracht = (response.data).data.find((opdract) => opdract.id == opdracht_id)
        });
    },

    handleUploadCV: function(identifier) {
      if (this.response_file_cv !== null) {
        return;
      }

      let field_name = 'documents';
      let field = this.$refs[field_name];
      let files = field.files;

      // Setup data
      let formData = new FormData();
      formData.append('type', 'cv');

      for (let file_i = 0; file_i < files.length; file_i++) {
        formData.append(`${field_name}[${file_i}]`, files[file_i]);
      }

      // Activate loading
      this.loadingActive();

      axios.post( `${_helpers.attribute('api_endpoint')}/api/dashboard/users/create_spelshow_aanmelding_document?identifier=${identifier}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then( response => {
        this.response_file_cv = response.data;
        this.form.upload_errors.documents = [];

        for (let i = 0; i < 5; i++) {
          this.form.upload_errors['documents.'+i] = [];
        }
      }).catch( error  => {
        this.activateNotDone();

        this.form.upload_errors = {
          ..._helpers.setAllObjectPropertiesToArray(this.form.upload_errors),
          ...(error.response !== undefined ? error.response.data.errors : []),
        };

        _helpers.scrollIntoView('.stent-form-errors');
      }).finally(() => {
        _helpers.scrollIntoView('.stent-form-errors');
        this.loadingDone();
      });
    },

    handleUploadPicturesSingle: function(identifier) {
      if (this.response_file_photo !== null) {
        return;
      }

      let field_name = 'pictures';
      let files = this.form.upload_files.pictures;

      // Activate loading
      this.loadingActive();

      for (let file_i = 0; file_i < files.length; file_i++) {
        let formData = new FormData();
        formData.append(`${field_name}[${file_i}]`, files[file_i]);

        axios.post(`${_helpers.attribute('api_endpoint')}/api/dashboard/users/create_spelshow_aanmelding_foto?identifier=${identifier}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((file_response) => {
          this.response_file_photo = file_response.data;
          this.form.upload_errors.pictures = [];

          for (let i = 0; i < 5; i++) {
            this.form.upload_errors['pictures.'+i] = [];
          }
        }).catch((error) => {
          this.activateNotDone();

          this.form.upload_errors = {
            ..._helpers.setAllObjectPropertiesToArray(this.form.upload_errors),
            ...(error.response !== undefined ? error.response.data.errors : []),
          };

          _helpers.scrollIntoView('.stent-form-errors');
        }).finally(() => {
          _helpers.scrollIntoView('.stent-form-errors');

          if (files.length === file_i) {
            this.loadingDone();
          }
        });
      }
    },

    handleUpload: async function () {
      let identifier = _helpers.formatUserUploadIdentifier(this.form.response.user);

      await this.loadingActive();
      await this.handleUploadCV(identifier);
      await this.handleUploadPicturesSingle(identifier);
      await this.loadingDone();
    },

    submit: function () {
      this.submitted = true;

      this.loadingActive();

      if (! _helpers.isEmptyObject(this.form.response)) {
        this.handleUpload();

        // Stop execution.
        return;
      }

      axios.post(`${_helpers.attribute('api_endpoint')}/api/dashboard/users/create_spelshow_aanmelding`, this.form.data)
        .then((response) => {
          this.form.response = response.data;
          this.form.errors = _helpers.setAllObjectProperties(this.form.errors, []);

          this.handleUpload();
        })
        .catch((error) => {
          this.activateNotDone();

          this.form.errors = {
            ..._helpers.setAllObjectPropertiesToArray(this.form.errors),
            ...(error.response !== undefined ? error.response.data.errors : []),
          };

          _helpers.scrollIntoView('.stent-form-errors');
        })
        .finally(() => {
          _helpers.scrollIntoView('.stent-form-errors');
          this.loadingDone();
        });
    },

    activateDone: function () {
      this.done = true;
      _helpers.scrollIntoView('#stent-inschrijven-spelshow');
    },

    activateNotDone: function () {
      this.done = false;
    },

    loadingActive: function () {
      this.loading = true;
    },

    loadingDone: function () {
      this.loading = false;
    },

    setPicturesFiles() {
      this.form.upload_files.pictures = _helpers.fileListToArray(this.form.upload_files.pictures)
        .concat(
          _helpers.fileListToArray(this.$refs.pictures.files)
        );
    },

    removePicturesFile(index) {
      _helpers.removeFromArrayByIndex(this.form.upload_files.pictures, index);
    },

    setDocumentsFiles() {
      this.form.upload_files.documents = this.$refs.documents.files;
    },

    removeDocumentsFile() {
      this.form.upload_files.documents = [];
    },
  },
};
</script>
